export enum SalaryType {
  Annual = "ANNUAL",
  Hourly = "HOURLY"
}